'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondsBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/millisecondsBefore.js
// module id = 180
// module chunks = 0